import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ApplicationUserViewModel } from '../../models';

export interface IapplicationUserService {
    getAllUsersWithRoles(applicationGuid: string): angular.IPromise<ApplicationUserViewModel[]>;
    getAllUsersWithRoles(applicationGuid: string, force: boolean): angular.IPromise<ApplicationUserViewModel[]>;
    getUsers(applicationGuid: string): angular.IPromise<ApplicationUserViewModel[]>;
    getUsers(applicationGuid: string, force: boolean): angular.IPromise<ApplicationUserViewModel[]>;
}

export class ApplicationUserService implements IapplicationUserService {
    static serviceId = 'applicationUserService';
    
    private _controllerUrl = 'applicationUser/';
    
    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getAllUsersWithRoles(applicationGuid: string, force: boolean = false): angular.IPromise<ApplicationUserViewModel[]> {
        const url = `${this._controllerUrl}usersWithRoles/${applicationGuid}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    getUsers(applicationGuid: string, force: boolean = false): angular.IPromise<ApplicationUserViewModel[]> {
        const url = `${this._controllerUrl}users/${applicationGuid}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

}